import { Injectable, signal } from '@angular/core';
import { IPickupLocation } from './models/pickup-location.interface';

@Injectable({ providedIn: 'root' })
export class PickupLocationStateService {
    public selectedPickupLocation$ = signal<IPickupLocation>(null);
}
